<script>
  import { onMount } from "svelte";
  import {
    API_DIR,
    SESSION_LS,
    selectedDevices,
    selectedPage,
    tableData
  } from "../store";
  import { toasts } from "svelte-toasts";
  import { each } from "svelte/internal";

  let selectedDeviceObj;
  let dbConfigFiles = [];
  //let uniqueFirmwares = getFirmwareList();
  let sortedDevices = {};
  let configSelection = {};

  const actTypeEnum = {
    LMU: "LMU",
    JPOD: "JPOD",
    JPOD2: "JPOD2"
  };

  function sortDevices() {
    $selectedDevices.forEach((device) => {
      if (sortedDevices[device.app] == undefined) {
        sortedDevices[device.app] = {};
      }

      if (sortedDevices[device.app][device.app_id] == undefined) {
        sortedDevices[device.app][device.app_id] = [];
      }

      let vbusJpod;
      if (device.hasOwnProperty("VBUS")) {
        let vbus;

        vbus = device.VBUS.split(",");

        if (vbus[0] == "1") {
          vbusJpod = actTypeEnum.JPOD;
        }

        if (vbus[0] == "8") {
          vbusJpod = actTypeEnum.JPOD2;
        }
      } else {
        vbusJpod = "None";
      }
      if (sortedDevices[device.app][device.app_id][vbusJpod] == undefined) {
        sortedDevices[device.app][device.app_id][vbusJpod] = [];
      }

      sortedDevices[device.app][device.app_id][vbusJpod].push(device);
    });
  }

  function filterCompatibleFwByAppId(appId, firmwareData, jpod) {
    const compatibleConfig = [];

    for (const firmware of firmwareData) {
      const { app_id, type } = firmware;

      if (!actTypeEnum.hasOwnProperty(jpod)) {
        if (type != actTypeEnum.JPOD && type != actTypeEnum.JPOD2) {
          if (app_id.includes(appId)) {
            compatibleConfig.push(firmware);
          }
        }
      } else if (actTypeEnum.hasOwnProperty(jpod)) {
        if (type == jpod || type == actTypeEnum.LMU) {
          if (app_id.includes(appId)) {
            compatibleConfig.push(firmware);
          }
        }
      }
    }
    return compatibleConfig;
  }

  async function fetchConfigData() {
    try {
      const response = await fetch(`${$API_DIR}/api/v1/config-files`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Session-Id": localStorage.getItem($SESSION_LS)
        }
      });
      if (response.status === 401) {
        location.reload();
      }
      if (!response.ok) {
        throw new Error("Error al obtener los archivos de configuración");
      }
      let data = await response.json();
      //console.log(data);
      //console.log("Compatible appId", isAppIdCompatible(selectedDeviceObj,data));

      if (data.length < 1) {
        alert("No Config Files with compatible AppId and Firmware Found");
        selectedPage.set(1);
        return [];
      } else if (data.length > 0) {
        return data;
      } else {
        alert("No Config Files Found");
        selectedPage.set(1);
        return [];
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  async function updateDeviceGroup(firmware, appId, jpod) {
    if (
      configSelection[firmware] != undefined &&
      configSelection[firmware][appId] != undefined &&
      configSelection[firmware][appId][jpod] != undefined
    ) {
      console.log(configSelection[firmware][appId][jpod]);
      let statusContainer = document.getElementById(
        `config-content-${firmware}-${appId}-${jpod}`
      );

      let titleContainer = document.getElementById(
        `config-title-${firmware}-${appId}-${jpod}`
      );

      statusContainer.innerHTML = ""; // Limpiamos el contenido anterior
      titleContainer.innerHTML = `Updates: <span id="updates-success-${firmware}-${appId}-${jpod}">0</span> uploaded, <span id="updates-failed-${firmware}-${appId}-${jpod}">0</span> failed`;

      let succesCounter = parseInt(
        document.getElementById(`updates-success-${firmware}-${appId}-${jpod}`)
          .innerText
      );

      let failedCounter = parseInt(
        document.getElementById(`updates-failed-${firmware}-${appId}-${jpod}`)
          .innerText
      );

      for (const device of sortedDevices[firmware][appId][jpod]) {
        console.log("device:", device.id_device);
        let responseCode = await updateDeviceConfig(
          device.id_device,
          configSelection[firmware][appId][jpod]["version"],
          device.app_id,
          configSelection[firmware][appId][jpod]["update_firmware"],
          configSelection[firmware][appId][jpod]["filename"],
          configSelection[firmware][appId][jpod]["type"],
          device.imsi,
          configSelection[firmware][appId][jpod]["auth"]
        );

        let listItem = document.createElement("div");
        listItem.className = "alert";

        {
          responseCode;
        }

        if (responseCode === 200) {
          listItem.classList.add("alert-success");
          listItem.innerHTML = `<i class="bi bi-check-square-fill"></i> <strong>${device.id_device}:</strong> Update in process!`;
          succesCounter++;
        } else if (responseCode === 402) {
          listItem.classList.add("alert-warning");
          listItem.innerHTML = `<i class="bi bi-exclamation-square-fill"></i> <strong>${device.id_device}:</strong> Update Error: You are not allowed to update this device.`;
          failedCounter++;
        } else {
          listItem.classList.add("alert-danger");
          listItem.innerHTML = `<i class="bi bi-x-square-fill"></i> <strong>${device.id_device}:</strong> Update Error.`;
          failedCounter++;
        }

        titleContainer.innerHTML = `Updates: <strong><span class="text-success" id="updates-success-${firmware}-${appId}-${jpod}">${succesCounter}</span></strong> uploaded, <strong><span id="updates-failed-${firmware}-${appId}-${jpod}">${failedCounter}</span></strong> failed.`;
        statusContainer.appendChild(listItem);
      }
    } else {
      toasts.error("Invalid Selection");
    }
  }

  async function updateDeviceConfig(
    deviceId,
    updatedVersion,
    updateAppId,
    updateFW,
    filename,
    type,
    imsi,
    auth
  ) {
    if (
      configSelection != -1 &&
      deviceId != undefined &&
      updateAppId != undefined &&
      updateFW != undefined &&
      filename != undefined &&
      type != undefined
    ) {
      const url = `${$API_DIR}/api/v1/upload-config-update`;

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Session-Id": localStorage.getItem($SESSION_LS)
        },
        body: JSON.stringify({
          device_id: deviceId,
          version: updatedVersion,
          app_id: updateAppId,
          filename: filename,
          firmware: updateFW,
          type: type,
          imsi: imsi,
          auth: auth
        })
      };

      try {
        const response = await fetch(url, requestOptions);

        if (response.status == 401) {
          location.reload();
        } else if (!response.ok) {
          return response.status;
        } else {
          return response.status;
        }
      } catch (error) {
        //alert("Error: " + error.message);
        console.log("Error:", error);
        return 500;
      }
    } else {
      //alert("Invalid Selection");
      return -1;
    }
  }

  sortDevices();
  console.log(sortedDevices);

  onMount(async () => {
    dbConfigFiles = await fetchConfigData();

    //console.log(dbConfigFiles);
  });
</script>

<div>
  <hr />
  <div class="d-flex justify-content-between">
    <h3>Update Config Version</h3>

    <button
      type="button"
      class="btn btn-outline-danger"
      style="margin-right: 12px;"
      on:click={() => {
        selectedPage.set(3);
      }}><i class="bi bi-x-square" /> Close</button
    >
  </div>
  <hr />

  <!--contenedores de devices-->

  {#each Object.keys(sortedDevices) as firmware}
    {#each Object.keys(sortedDevices[firmware]) as appId}
      {#each Object.keys(sortedDevices[firmware][appId]) as jpod}
        <div class="row" style="max-height: 500px;">
          <div
            class="col-md-6 border border-1 rounded m-2 p-2"
            style="border-color: #C6C7C8; max-height:inherit;"
          >
            <h5>
              Firmware: <strong>{firmware}</strong> / {Object.keys(
                sortedDevices[firmware][appId][jpod]
              ).length}
              {Object.keys(sortedDevices[firmware][appId][jpod]).length == 1
                ? "Device"
                : "Devices"} / JPOD: {jpod}
            </h5>
            <hr />
            <div class="table-container">
              <table class="table table-hover">
                <thead class="table-light">
                  <tr>
                    <th scope="col" class="header">Device Id</th>
                    <th scope="col" class="header">App Id</th>
                    <th scope="col" class="header">Firmware</th>
                    <th scope="col" class="header">Script</th>
                    <th scope="col" class="header">Config</th>
                  </tr>
                </thead>
                <tbody class="tbody-scroll">
                  {#each sortedDevices[firmware][appId][jpod] as device}
                    <tr>
                      <td>{device.id_device}</td>
                      <td>{device.app_id}</td>
                      <td>{device.app}</td>
                      <td>{device.script}</td>
                      <td>{device.config}</td>
                    </tr>
                  {/each}
                </tbody>
              </table>
            </div>
          </div>

          <div
            class="col-md border border-1 rounded m-2 p-2"
            style="border-color: #C6C7C8; max-height:inherit"
          >
            <div
              id="config-version-selector-{firmware}-{appId}-{jpod}"
              style="overflow:auto;max-height: 100%; height:100%;"
            >
              <div>
                <h5 id="config-title-{firmware}-{appId}-{jpod}">
                  File / App ID / Compatible FW:
                </h5>
                <hr />

                <div
                  id="config-content-{firmware}-{appId}-{jpod}"
                  style="margin: 8px;"
                >
                  {#if (dbConfigFiles.length > 0) & (filterCompatibleFwByAppId(appId, dbConfigFiles, jpod).length > 0)}
                    <select
                      class="form-select"
                      id="configSelection-{firmware}-{appId}-{jpod}"
                      on:change={(event) => {
                        const selectedValue = JSON.parse(event.target.value);

                        if (configSelection[firmware] == undefined) {
                          configSelection[firmware] = {};
                        }

                        if (configSelection[firmware][appId] == undefined) {
                          configSelection[firmware][appId] = {};
                        }

                        if (
                          configSelection[firmware][appId][jpod] == undefined
                        ) {
                          configSelection[firmware][appId][jpod] = {};
                        }

                        configSelection[firmware][appId][jpod] = {
                          value: 1,
                          update_firmware: firmware,
                          app_id: appId,
                          version: selectedValue.version,
                          filename: selectedValue.filename,
                          type: selectedValue.type,
                          auth: selectedValue.auth
                        };
                      }}
                    >
                      <option value="-1">File / AppID / FW Version </option>
                      {#each filterCompatibleFwByAppId(appId, dbConfigFiles, jpod) as option}
                        <option value={JSON.stringify(option)}>
                          {option.filename} / {option.app_id} / {option.compatible_firmware}
                        </option>
                      {/each}
                    </select>

                    <br />

                    <div class="">
                      <div class="d-flex justify-content-end">
                        <!--<button
                          type="button"
                          class="btn btn-outline-success"
                          style="margin-right: 8px;"
                          data-bs-toggle="tooltip" data-bs-placement="top" title="Add task to queue"
                          on:click={async () => {
                            //await updateDeviceGroup(firmware, appId, jpod);
                          }}
                          ><i class="bi bi-plus-circle" />
                        </button> -->

                        <button
                          type="button"
                          class="btn btn-outline-primary"
                          on:click={async () => {
                            await updateDeviceGroup(firmware, appId, jpod);
                          }}><i class="bi bi-arrow-up-square" /> Update</button
                        >
                      </div>
                    </div>
                  {:else}
                    <h4>No firmware update available.</h4>
                  {/if}
                </div>
              </div>
            </div>
          </div>
        </div>

        <br />
      {/each}
    {/each}
  {/each}
</div>

<style>
  .table-container {
    overflow: hidden; /* Oculta el desplazamiento vertical en el contenedor */
    max-height: 90%;
    overflow: auto;
  }

  .table-container table {
    width: 100%;
    table-layout: fixed; /* Asegura que la tabla ocupe el ancho completo del contenedor */
  }

  .table-container .tbody-scroll {
    max-height: calc(
      100% - 37px
    ); /* Establece la altura máxima del tbody (altura del contenedor - altura del encabezado) */
    overflow-y: auto; /* Agrega un desplazamiento vertical solo al tbody si el contenido excede la altura máxima */
  }

  .header {
    position: sticky;
    top: 0;
  }
</style>
